import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const TABS = ["学校登録", "教師登録", "生徒一括登録", "Bot管理"];

export default function AdminPage() {
  const { token, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);
  const [schools, setSchools] = useState([]);
  const [users, setUsers] = useState([]);
  const [students, setStudents] = useState([]);
  const [bots, setBots] = useState([]);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [bulkText, setBulkText] = useState("");
  const [bulkSchoolId, setBulkSchoolId] = useState("");
  const [editUser, setEditUser] = useState(null);
  const [editStudent, setEditStudent] = useState(null);
  const [newBot, setNewBot] = useState({ bot_key:"", bot_name:"", role:"troublemaker", dify_api_url:"https://treasure-max.net/v1", dify_api_key:"" });

  function loadAll() {
    fetch("/api/bots", { headers: { Authorization: "Bearer " + token } })
      .then(r => r.json()).then(setBots).catch(console.error);
    fetch("/api/admin/schools-list", { headers: { Authorization: "Bearer " + token } })
      .then(r => r.json()).then(setSchools).catch(console.error);
    fetch("/api/admin/users-list", { headers: { Authorization: "Bearer " + token } })
      .then(r => r.json()).then(setUsers).catch(console.error);
    fetch("/api/admin/students-list", { headers: { Authorization: "Bearer " + token } })
      .then(r => r.json()).then(setStudents).catch(console.error);
  }

  useEffect(() => { loadAll(); }, [token]);

  async function createSchool(e) {
    e.preventDefault(); setMsg(""); setError("");
    const fd = new FormData(e.target);
    try {
      const r = await fetch("/api/admin/schools", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({
          school_code: fd.get("school_code"), school_name: fd.get("school_name"),
          school_type: fd.get("school_type"), contract_start: fd.get("contract_start"),
          contract_end: fd.get("contract_end")
        })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg("学校を登録しました：" + d.school_name);
      loadAll(); e.target.reset();
    } catch(err) { setError(err.message); }
  }

  async function createUser(e) {
    e.preventDefault(); setMsg(""); setError("");
    const fd = new FormData(e.target);
    try {
      const r = await fetch("/api/admin/users", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({
          school_id: Number(fd.get("school_id")), login_id: fd.get("login_id"),
          password: fd.get("password"), display_name: fd.get("display_name"), role: fd.get("role")
        })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg("教師を登録しました：" + d.login_id);
      loadAll(); e.target.reset();
    } catch(err) { setError(err.message); }
  }

  async function updateUser(e) {
    e.preventDefault(); setMsg(""); setError("");
    const fd = new FormData(e.target);
    try {
      const r = await fetch("/api/admin/users/" + editUser.id, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ display_name: fd.get("display_name"), password: fd.get("password") || undefined })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg("教師情報を更新しました");
      setEditUser(null); loadAll();
    } catch(err) { setError(err.message); }
  }

  async function updateStudent(e) {
    e.preventDefault(); setMsg(""); setError("");
    const fd = new FormData(e.target);
    try {
      const r = await fetch("/api/admin/students/" + editStudent.id, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ password: fd.get("password") })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg("生徒パスワードを更新しました");
      setEditStudent(null); loadAll();
    } catch(err) { setError(err.message); }
  }

  async function bulkRegister() {
    setMsg(""); setError("");
    if (!bulkSchoolId) { setError("学校を選択してください"); return; }
    if (!bulkText.trim()) { setError("生徒データを入力してください"); return; }
    const lines = bulkText.trim().split("\n").filter(l => l.trim());
    const studentList = [];
    for (const line of lines) {
      const cols = line.split("\t");
      if (cols.length < 4) continue;
      studentList.push({ grade: Number(cols[0]), class_name: cols[1].trim(), student_number: Number(cols[2]), password: cols[3].trim() });
    }
    if (studentList.length === 0) { setError("有効なデータがありません"); return; }
    try {
      const r = await fetch("/api/admin/students/bulk", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ school_id: Number(bulkSchoolId), students: studentList })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg(d.count + "人の生徒を登録しました");
      setBulkText(""); loadAll();
    } catch(err) { setError(err.message); }
  }

  async function updateBot(e, botId) {
    e.preventDefault(); setMsg(""); setError("");
    const fd = new FormData(e.target);
    try {
      const r = await fetch("/api/bots/" + botId, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ dify_api_url: fd.get("dify_api_url"), dify_api_key: fd.get("dify_api_key"), is_active: fd.get("is_active") === "true" })
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg("Bot設定を更新しました：" + d.bot_name);
      loadAll();
    } catch(err) { setError(err.message); }
  }

  async function addBot(e) {
    e.preventDefault(); setMsg(""); setError("");
    try {
      const r = await fetch("/api/bots", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify(newBot)
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg("Botを追加しました：" + d.bot_name);
      setNewBot({ bot_key:"", bot_name:"", role:"troublemaker", dify_api_url:"https://treasure-max.net/v1", dify_api_key:"" });
      loadAll();
    } catch(err) { setError(err.message); }
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.sidebar}>
        <div style={styles.sideHead}>
          <div style={styles.sideTitle}>管理者画面</div>
          <div style={styles.sideSub}>SNSまなびチャット</div>
        </div>
        {TABS.map((t, i) => (
          <div key={i} style={{...styles.sideItem, ...(tab===i ? styles.sideItemActive : {})}}
            onClick={() => { setTab(i); setMsg(""); setError(""); setEditUser(null); setEditStudent(null); }}>
            {t}
          </div>
        ))}
        <div style={styles.sideFooter}>
          <button style={styles.logoutBtn} onClick={() => { logout(); navigate("/login"); }}>ログアウト</button>
        </div>
      </div>

      <div style={styles.main}>
        <div style={styles.mainHead}><h1 style={styles.h1}>{TABS[tab]}</h1></div>
        <div style={styles.content}>
          {msg && <div style={styles.success}>{msg}</div>}
          {error && <div style={styles.error}>{error}</div>}

          {tab === 0 && (
            <div style={styles.twoCol}>
              <div>
                <h3 style={styles.h3}>新規登録</h3>
                <form onSubmit={createSchool} style={styles.form}>
                  <input name="school_code" style={styles.input} placeholder="学校コード（例：SCHOOL01）" required />
                  <input name="school_name" style={styles.input} placeholder="学校名" required />
                  <select name="school_type" style={styles.input}>
                    <option value="elementary">小学校</option>
                    <option value="junior">中学校</option>
                    <option value="high">高等学校</option>
                    <option value="special">特別支援学校</option>
                    <option value="university">大学・専門学校</option>
                    <option value="company">社会人・企業</option>
                  </select>
                  <div style={styles.row}>
                    <div style={styles.col}>
                      <label style={styles.label}>契約開始日</label>
                      <input name="contract_start" type="date" style={styles.input} required />
                    </div>
                    <div style={styles.col}>
                      <label style={styles.label}>契約終了日</label>
                      <input name="contract_end" type="date" style={styles.input} required />
                    </div>
                  </div>
                  <button style={styles.btnPrimary}>学校を登録</button>
                </form>
              </div>
              <div>
                <h3 style={styles.h3}>登録済み学校（{schools.length}件）</h3>
                <table style={styles.table}>
                  <thead><tr><th style={styles.th}>ID</th><th style={styles.th}>コード</th><th style={styles.th}>学校名</th><th style={styles.th}>種別</th></tr></thead>
                  <tbody>{schools.map(s => (<tr key={s.id}><td style={styles.td}>{s.id}</td><td style={styles.td}>{s.school_code}</td><td style={styles.td}>{s.school_name}</td><td style={styles.td}>{s.school_type}</td></tr>))}</tbody>
                </table>
              </div>
            </div>
          )}

          {tab === 1 && (
            <div style={styles.twoCol}>
              <div>
                <h3 style={styles.h3}>新規登録</h3>
                <form onSubmit={createUser} style={styles.form}>
                  <select name="school_id" style={styles.input} required>
                    <option value="">学校を選択</option>
                    {schools.map(s => (<option key={s.id} value={s.id}>{s.school_name}({s.school_code})</option>))}
                  </select>
                  <input name="display_name" style={styles.input} placeholder="表示名（例：田中先生）" required />
                  <input name="login_id" style={styles.input} placeholder="ログインID" required />
                  <input name="password" type="text" style={styles.input} placeholder="パスワード" required />
                  <select name="role" style={styles.input}>
                    <option value="teacher">教師</option>
                  </select>
                  <button style={styles.btnPrimary}>教師を登録</button>
                </form>

                {editUser && (
                  <div style={styles.editBox}>
                    <h3 style={styles.h3}>編集：{editUser.login_id}</h3>
                    <form onSubmit={updateUser} style={styles.form}>
                      <input name="display_name" type="text" style={styles.input} defaultValue={editUser.display_name} placeholder="表示名" required />
                      <input name="password" type="text" style={styles.input} placeholder="新しいパスワード（変更する場合のみ）" />
                      <div style={styles.row}>
                        <button style={styles.btnPrimary}>更新</button>
                        <button type="button" style={styles.btnCancel} onClick={() => setEditUser(null)}>キャンセル</button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
              <div>
                <h3 style={styles.h3}>登録済み教師（{users.length}件）</h3>
                <table style={styles.table}>
                  <thead><tr><th style={styles.th}>ID</th><th style={styles.th}>ログインID</th><th style={styles.th}>表示名</th><th style={styles.th}>学校</th><th style={styles.th}>操作</th></tr></thead>
                  <tbody>{users.map(u => (
                    <tr key={u.id}>
                      <td style={styles.td}>{u.id}</td>
                      <td style={styles.td}>{u.login_id}</td>
                      <td style={styles.td}>{u.display_name}</td>
                      <td style={styles.td}>{u.school_name}</td>
                      <td style={styles.td}><button style={styles.btnSmall} onClick={() => setEditUser(u)}>編集</button></td>
                    </tr>
                  ))}</tbody>
                </table>
              </div>
            </div>
          )}

          {tab === 2 && (
            <div style={styles.twoCol}>
              <div>
                <h3 style={styles.h3}>一括登録</h3>
                <div style={styles.form}>
                  <select style={styles.input} value={bulkSchoolId} onChange={e => setBulkSchoolId(e.target.value)}>
                    <option value="">学校を選択</option>
                    {schools.map(s => (<option key={s.id} value={s.id}>{s.school_name}({s.school_code})</option>))}
                  </select>
                  <div style={styles.bulkGuide}>Excelから学年・組・番号・パスワードの4列をコピペしてください</div>
                  <textarea style={styles.bulkInput} value={bulkText} onChange={e => setBulkText(e.target.value)} placeholder="1    1組    1    pass001" />
                  <button style={styles.btnPrimary} onClick={bulkRegister}>一括登録</button>
                </div>

                {editStudent && (
                  <div style={styles.editBox}>
                    <h3 style={styles.h3}>パスワード変更：{editStudent.grade}年{editStudent.class_name} {editStudent.student_number}番</h3>
                    <form onSubmit={updateStudent} style={styles.form}>
                      <input name="password" type="text" style={styles.input} placeholder="新しいパスワード" required />
                      <div style={styles.row}>
                        <button style={styles.btnPrimary}>更新</button>
                        <button type="button" style={styles.btnCancel} onClick={() => setEditStudent(null)}>キャンセル</button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
              <div>
                <h3 style={styles.h3}>登録済み生徒（{students.length}人）</h3>
                <table style={styles.table}>
                  <thead><tr><th style={styles.th}>学校</th><th style={styles.th}>学年</th><th style={styles.th}>組</th><th style={styles.th}>番号</th><th style={styles.th}>操作</th></tr></thead>
                  <tbody>{students.map(s => (
                    <tr key={s.id}>
                      <td style={styles.td}>{s.school_name}</td>
                      <td style={styles.td}>{s.grade}年</td>
                      <td style={styles.td}>{s.class_name}</td>
                      <td style={styles.td}>{s.student_number}番</td>
                      <td style={styles.td}><button style={styles.btnSmall} onClick={() => setEditStudent(s)}>PW変更</button></td>
                    </tr>
                  ))}</tbody>
                </table>
              </div>
            </div>
          )}

          {tab === 3 && (
            <div style={styles.twoCol}>
              <div>
                <h3 style={styles.h3}>Bot追加</h3>
                <form onSubmit={addBot} style={styles.form}>
                  <input style={styles.input} placeholder="Botキー（例：helper）" value={newBot.bot_key} onChange={e => setNewBot({...newBot, bot_key:e.target.value})} required />
                  <input style={styles.input} placeholder="Bot名（例：ヘルパーさん）" value={newBot.bot_name} onChange={e => setNewBot({...newBot, bot_name:e.target.value})} required />
                  <select style={styles.input} value={newBot.role} onChange={e => setNewBot({...newBot, role:e.target.value})}>
                    <option value="troublemaker">トラブルメーカー</option>
                    <option value="facilitator">ファシリテーター</option>
                    <option value="other">その他</option>
                  </select>
                  <input style={styles.input} placeholder="Dify API URL" value={newBot.dify_api_url} onChange={e => setNewBot({...newBot, dify_api_url:e.target.value})} required />
                  <input style={styles.input} placeholder="Dify APIキー" value={newBot.dify_api_key} onChange={e => setNewBot({...newBot, dify_api_key:e.target.value})} required />
                  <button style={styles.btnPrimary}>Botを追加</button>
                </form>
              </div>
              <div>
                <h3 style={styles.h3}>登録済みBot（{bots.length}件）</h3>
                {bots.map(bot => (
                  <div key={bot.id} style={styles.botCard}>
                    <div style={styles.botTitle}>
                      {bot.bot_name}
                      <span style={{...styles.botBadge, background: bot.is_active ? "#064e3b" : "#7f1d1d", color: bot.is_active ? "#6ee7b7" : "#fca5a5"}}>{bot.is_active ? "有効" : "無効"}</span>
                      <span style={styles.botBadge}>{bot.role}</span>
                    </div>
                    <form onSubmit={e => updateBot(e, bot.id)} style={{display:"flex", flexDirection:"column", gap:6}}>
                      <input name="dify_api_url" style={styles.input} defaultValue={bot.dify_api_url || "https://treasure-max.net/v1"} placeholder="Dify API URL" />
                      <input name="dify_api_key" style={styles.input} placeholder="APIキー（変更する場合のみ）" />
                      <div style={styles.row}>
                        <select name="is_active" style={{...styles.input, flex:1}} defaultValue={String(bot.is_active)}>
                          <option value="true">有効</option>
                          <option value="false">無効</option>
                        </select>
                        <button style={styles.btnSecondary}>更新</button>
                      </div>
                    </form>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: { display: "flex", height: "100vh", overflow: "hidden", background: "var(--bg-dark)" },
  sidebar: { width: 220, background: "#0d0d1a", display: "flex", flexDirection: "column", flexShrink: 0 },
  sideHead: { padding: 16, borderBottom: "1px solid var(--border)" },
  sideTitle: { color: "#fff", fontWeight: 700, fontSize: 14 },
  sideSub: { color: "var(--text-muted)", fontSize: 11, marginTop: 2 },
  sideItem: { padding: "10px 16px", cursor: "pointer", color: "var(--text-muted)", fontSize: 13 },
  sideItemActive: { background: "var(--bg-light)", color: "var(--text)" },
  sideFooter: { marginTop: "auto", padding: 16, borderTop: "1px solid var(--border)" },
  logoutBtn: { width: "100%", padding: 8, borderRadius: 6, background: "transparent", border: "1px solid var(--border)", color: "var(--text-muted)", fontSize: 12 },
  main: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" },
  mainHead: { padding: "16px 24px", borderBottom: "1px solid var(--border)" },
  h1: { fontSize: 18, fontWeight: 700, color: "var(--text)" },
  h3: { fontSize: 14, fontWeight: 700, color: "var(--text)", marginBottom: 10 },
  content: { flex: 1, overflowY: "auto", padding: 24 },
  twoCol: { display: "flex", gap: 32, flexWrap: "wrap" },
  form: { display: "flex", flexDirection: "column", gap: 10, maxWidth: 360 },
  row: { display: "flex", gap: 8 },
  col: { flex: 1, display: "flex", flexDirection: "column", gap: 4 },
  label: { fontSize: 12, color: "var(--text-muted)" },
  input: { padding: "8px 12px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--bg-mid)", color: "var(--text)", fontSize: 13, width: "100%" },
  btnPrimary: { padding: "10px 16px", borderRadius: 8, background: "var(--accent)", color: "#000", fontWeight: 700, fontSize: 13 },
  btnSecondary: { padding: "8px 16px", borderRadius: 8, background: "var(--accent2)", color: "#fff", fontWeight: 700, fontSize: 13 },
  btnSmall: { padding: "4px 10px", borderRadius: 6, background: "var(--bg-light)", color: "var(--text-muted)", fontSize: 12, cursor: "pointer", border: "1px solid var(--border)" },
  btnCancel: { padding: "10px 16px", borderRadius: 8, background: "transparent", border: "1px solid var(--border)", color: "var(--text-muted)", fontSize: 13, cursor: "pointer" },
  success: { background: "rgba(74,222,128,0.1)", border: "1px solid var(--accent)", borderRadius: 8, padding: "10px 14px", color: "var(--accent)", fontSize: 13, marginBottom: 16 },
  error: { background: "rgba(248,113,113,0.1)", border: "1px solid var(--danger)", borderRadius: 8, padding: "10px 14px", color: "var(--danger)", fontSize: 13, marginBottom: 16 },
  table: { borderCollapse: "collapse", fontSize: 12, minWidth: 300 },
  th: { padding: "6px 10px", background: "var(--bg-light)", color: "var(--text-muted)", textAlign: "left", borderBottom: "1px solid var(--border)" },
  td: { padding: "6px 10px", color: "var(--text)", borderBottom: "1px solid var(--border)" },
  editBox: { marginTop: 16, padding: 16, background: "var(--bg-mid)", borderRadius: 10, maxWidth: 360 },
  botCard: { background: "var(--bg-mid)", borderRadius: 10, padding: 14, marginBottom: 12, maxWidth: 400 },
  botTitle: { fontSize: 14, fontWeight: 700, color: "var(--text)", marginBottom: 10, display: "flex", alignItems: "center", gap: 6 },
  botBadge: { fontSize: 11, padding: "2px 8px", borderRadius: 12, background: "var(--bg-light)", color: "var(--text-muted)" },
  bulkGuide: { color: "var(--text-muted)", fontSize: 12, lineHeight: 1.6 },
  bulkInput: { padding: "10px 14px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--bg-mid)", color: "var(--text)", fontSize: 13, height: 180, fontFamily: "monospace", width: "100%" },
};
